import { render, staticRenderFns } from "./black.vue?vue&type=template&id=482f39fc&scoped=true"
import script from "./black.vue?vue&type=script&lang=js"
export * from "./black.vue?vue&type=script&lang=js"
import style0 from "./black.vue?vue&type=style&index=0&id=482f39fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f39fc",
  null
  
)

export default component.exports